import { useState } from 'react'
import { Box, Tooltip } from '@chakra-ui/react'

import { CreateButtonWithPermission } from 'components/buttons'
import { useCustomFormBuilder } from '../../../../contexts/CustomFormBuilderManagerContext/Provider'

export default function CustomFormBuilderCreateQuestion() {
  const [loadingButton, setLoadingButton] = useState(false)

  const { isFormActionsDisabled, permissions, questions, createQuestion } = useCustomFormBuilder()

  async function onCreate() {
    setLoadingButton(true)

    //RECUPERANDO O MAIOR PAGE_ORDER
    const maxPageOrder = questions.reduce((max, item) => {
      const current = Number(item.page_order)
      return current > max ? current : max
    }, -Infinity)

    const DEFAULT_VALUES = {
      title: `Questão ${questions.length + 1}`,
      kind: 'SHORT_TEXT',
      page_order: maxPageOrder + 1,
    }

    const response = await createQuestion({ data: DEFAULT_VALUES })

    if (response) setLoadingButton(false)
  }

  if (isFormActionsDisabled) {
    return (
      <Tooltip label="Este formulário é protegido, não pode ser alterado / deletado">
        <Box>
          <CreateButtonWithPermission isDisabled width="full" size="md">
            Nova questão
          </CreateButtonWithPermission>
        </Box>
      </Tooltip>
    )
  }

  return (
    <CreateButtonWithPermission
      customDisableCondition={permissions?.createFormQuestion}
      onClick={() => onCreate()}
      width="full"
      size="md"
      isLoading={loadingButton}
    >
      Nova questão
    </CreateButtonWithPermission>
  )
}
